<template>
  <div class="medical-detail-cntainer">
    <TopBg title="数字化运维监控系统" sub-title="业务健康稳定运行的守护者！" :bg="topBg" />
    <div class="main-content page">
      <!-- 产品简介 -->
      <div class="section">
        <div class="title">产品简介</div>
        <div class="disc">
          数字化运维监控系统，能够对网络基础架构中的硬件、软件等信息化资产进行运行状态、资源使用及性能指标的统一监控和7*24小时实时预警，结合AI技术，提供智能告警、复杂问题根因定位、智能预警、智能巡检等功能模块，实现事前预警、事中定位和事后分析，全面保障业务系统的持续稳定运行。
        </div>
        <el-image :src="introImg" :preview-src-list="[introImg]" alt="product-intro" srcset="" />
      </div>

      <!-- 痛点分析 -->
      <div class="section">
        <div class="title">痛点分析</div>
        <div class="rows-4">
          <PainsAnalysisItem desc="资产类型繁多、冗杂，底数不清。">
            <template #icon>
              <img src="./assets/pain01.svg" alt="" />
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem desc="故障来临后知后觉，每日救火式运维。">
            <template #icon>
              <img src="./assets/pain02.svg" alt="" />
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem desc="业务复杂，故障处置耗时耗力。">
            <template #icon>
              <img src="./assets/pain03.svg" alt="" />
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem desc="运维人员不足，运维成本不断增加。">
            <template #icon>
              <img src="./assets/pain04.svg" alt="" />
            </template>
          </PainsAnalysisItem>
        </div>
      </div>

      <!-- 解决方案 -->
      <div class="section">
        <div class="title">解决方案</div>
        <div class="card">
          <SolutionItemV2 title="信息资产“一本帐”" desc="采用全网端口扫描、流量探测、指纹识别等技术，结合数字资产模型，从“未知”变为“可知”">
            <template #icon>
              <img src="./assets/solution01.svg" alt="" />
            </template>
          </SolutionItemV2>
          <div class="rows-2 mt-16">
            <div class="border radius-8 p-16 m-p-8">
              <div class="card-title">自学习式资产测绘(核心技术)</div>
              <div class="card-desc">
                通过资产发现引擎，实现网络设备、服务器、数据库、终端等全量信息资产的自动发现。
              </div>
            </div>
            <div class="border radius-8 p-16 m-p-8">
              <div class="card-title">全景式资产图谱</div>
              <div class="card-desc">
                能够根据各资产之间的关联关系，自动生成或手动编排资产图谱，更准确地评估资产价值、风险及影响范围。
              </div>
            </div>
          </div>
          <div class="rows-2 mt-16">
            <div class="border radius-8 p-16 m-p-8">
              <div class="card-title">数字化资产模型</div>
              <div class="card-desc">
                内置信息资产构建数据模型，并且能够自定义数据模型属性，实现对各类型资产的全信息录入管理。
              </div>
            </div>
            <div class="border radius-8 p-16 m-p-8">
              <div class="card-title">数字流风险管控</div>
              <div class="card-desc">
                自定义变更和发布的请求、审核、控制流程，确保变更符合规范和准则，防止潜在的问题和风险。
              </div>
            </div>
          </div>
          <div class="flex mt-16 m-rows-1">
            <el-image :src="solutionImg11" :preview-src-list="[solutionImg11]" />
            <el-image :src="solutionImg12" :preview-src-list="[solutionImg12]" />
          </div>
        </div>

        <div class="card mt-16">
          <SolutionItemV2 title="资产可用性监测" desc="一切可IP化的信息资产，全量监测管理，数万个监测指标，面向不同场景的颗粒度需求。">
            <template #icon>
              <img src="./assets/solution02.svg" alt="" />
            </template>
          </SolutionItemV2>
          <div class="flex mt-16">
            <el-image :src="solutionImg21" :preview-src-list="[solutionImg21]" />
          </div>
          <div class="mt-16 font-26 m-font-16 font-weight-500" >智能告警</div>
          <div class="rows-3 mt-16">
            <div class="border radius-8 p-16 m-p-8">
              <div class="card-title">1、告警降噪</div>
              <div class="card-desc">
                通过压缩、关联、抑制、富集技术，自动过滤重复/次生告警。
              </div>
            </div>
            <div class="border radius-8 p-16 m-p-8">
              <div class="card-title">2、告警分级</div>
              <div class="card-desc">
                基于资源类型、业务影响度进行告警定级。
              </div>
            </div>
            <div class="border radius-8 p-16 m-p-8">
              <div class="card-title">3、智能处置</div>
              <div class="card-desc">
                自动发送责任人，并附带故障解析、处置建议和影响范围。
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-16">
          <SolutionItemV2 title="业务健康画像"
            desc="结合真实业务场景，对关联的硬件和软件等资源进行业务建模和业务画像，从业务的可用性、可靠性及连续性实时感知业务系统的健康状态，保障业务系统持续稳定运行。">
            <template #icon>
              <img src="./assets/solution03.svg" alt="" />
            </template>
          </SolutionItemV2>

          <div class="mt-16" style="font-size: 26px; font-weight: 500;">智能告警</div>
          <div class="rows-2 mt-16">
            <div class="flex-vertical justify-between">
              <div class="border radius-8 px-16 py-24 m-p-8 m-m-b-8">
                <div class="card-title">业务画像</div>
                <div class="card-desc">
                  业务全景可视化，状态全面感知。
                </div>
              </div>
              <div class="border radius-8 px-16 py-24 m-p-8 m-m-b-8">
                <div class="card-title">业务建模</div>
                <div class="card-desc">
                  以业务视角自动生成业务关系图谱，实现异常节点快速定位。
                </div>
              </div>
              <div class="border radius-8 px-16 py-24 m-p-8">
                <div class="card-title">健康分析</div>
                <div class="card-desc">
                  从网络层、系统层、应用层等多维度，构建业务健康感知模型。
                </div>
              </div>
            </div>
            <div class="flex-1">
              <el-image :src="solutionImg31" :preview-src-list="[solutionImg31]" class="h-100"
                style="display: flex; align-items: stretch;" />
            </div>
          </div>
          <div class="rows-2 mt-16 border radius-8 p-16">
            <div class="flex-vertical">
              <div class="card-title">根因定位</div>
              <div class="mt-16">
                <div class="card-title">智能分析</div>
                <div class="card-desc">
                  自动提取关键日志、性能指标与配置变更作为判定依据，输出最可能根因的置信度及完整证据链，支撑快速决策。 </div>
              </div>
              <div class="mt-16 pt-16 border-top-dash">
                <div class="card-title">分钟级定位</div>
                <div class="card-desc">
                  将传统依赖人工排查的小时级故障定位，缩短至分钟级，极大减少业务中断时间。
                </div>
              </div>

            </div>
            <div>
              <el-image :src="solutionImg32" :preview-src-list="[solutionImg32]" />
            </div>
          </div>
        </div>

        <div class="card mt-16">
          <SolutionItemV2 title="智能网络管理" desc="针对网络中的不稳定要素提供智能化网络安全管理工具，提高网络运维工作效率，保障网络环境安全可靠。">
            <template #icon>
              <img src="./assets/solution04.svg" alt="" />
            </template>
          </SolutionItemV2>
          <div class="mt-16">
            <el-image :src="solutionImg41" :preview-src-list="[solutionImg41]" />
          </div>
        </div>

        <div class="card mt-16">
          <SolutionItemV2 title="低代码3D机房"
            desc="采用3D数字可视化技术，通过对机房、机柜、IT设备、动环设备、安防设备等进行三维建模和动态仿真，实时掌握机房运作的有效信息，提升数据中心机房的管理水平和效率，塑造全新机房监控的形象。">
            <template #icon>
              <img src="./assets/solution05.svg" alt="" />
            </template>
          </SolutionItemV2>
          <div class="mt-16 flex">
            <div class="flex-1">
              <div class="under-line-title">低代码高效构建3D机房</div>
              <div class="under-line-title mt-16">资产、告警、容量可视化</div>
              <div class="under-line-section">
                <div class="under-line-section-title">1天快速搭建</div>
                <div class="under-line-section-subTitle">数据中心全景可视化</div>
              </div>
            </div>
            <el-image class="flex-3" :src="solutionImg51" :preview-src-list="[solutionImg51]" />
          </div>
        </div>

        <div class="card mt-16">
          <SolutionItemV2 title="弱电间空间安全管理"
            desc="实现对机房、弱电间的温度、湿度、烟感、水浸等环境指标进行7*24小时不间断的全面监控，通过以太网的方式进行数据上传，对异常监测节点进行移动端告警信息推送，实时保障IT基础设施的安全。">
            <template #icon>
              <img src="./assets/solution06.svg" alt="" />
            </template>
          </SolutionItemV2>
          <div class="mt-16">
            <el-image :src="solutionImg61" :preview-src-list="[solutionImg61]" />
          </div>

          <div class="card mt-16">
            <SolutionItemV2 title="运维可视中台"
              desc="从业务、资产等维度对信息化资产进行全方位、立体化展示，通过强大的数据分析算法及处理亿万级数据的能力，以全局视角实时掌握业务系统及资产的运行状态，对于更加复杂的业务需求，提供场景化服务。">
              <template #icon>
                <img src="./assets/solution07.svg" alt="" />
              </template>
            </SolutionItemV2>
            <div class="mt-16 flex">
              <div class="flex-1" style="margin-right: 86px;">
                <div class="under-line-title">信息资产运行状态全掌控</div>
                <div class="under-line-title mt-16">异常告警信息及时发现</div>
                <div class="under-line-title mt-16">网络、业务场景可视化</div>
              </div>
              <el-image class="flex-3" :src="solutionImg71" :preview-src-list="[solutionImg71]" />
            </div>
          </div>

          <div class="card mt-16">
            <SolutionItemV2 title="统一门户系统" desc="致力于构建IT运维中台，打破信息壁垒，摆脱孤岛式运维，实现跨系统单点登录，告警消息统一推送。">
              <template #icon>
                <img src="./assets/solution08.svg" alt="" />
              </template>
            </SolutionItemV2>
            <div class="mt-16 rows-2 radius-8 bg-green p-16">
              <div class="flex-vertical space-between h-100">
                <div class="flex-1">
                  <div class="card-title">应用门户中心</div>
                  <div class="card-desc">实现各类型设备/系统的统一单点登录服务。</div>
                </div>
                <div class="mb-40">
                  <div class="under-line-title font-18">
                    <div class="under-line-title-title">兼容性</div>
                    <div class="under-line-title-desc">信息资产运行状态全掌控</div>
                  </div>
                  <div class="under-line-title mt-16 font-18">
                    <div class="under-line-title-title">安全性</div>
                    <div class="under-line-title-desc">
                      同态加密:加密机制采用的是Hash、Token双层不可逆加密，确保三方系统的账户信息安全。</div>
                  </div>
                </div>
              </div>
              <el-image :src="solutionImg81" :preview-src-list="[solutionImg81]" />
            </div>
            <div class="mt-16 rows-2 radius-8 bg-green p-16 ">
              <div class="flex-vertical space-between h-100">
                <div class="flex-1">
                  <div class="card-title">消息管理中心</div>
                  <div class="card-desc">实现对各类型设备及应用资产的日志、告警、事件的管理。</div>
                </div>
                <div class="mb-40">
                  <div class="under-line-title font-18">
                    <div class="under-line-title-title">数据采集</div>
                    <div class="under-line-title-desc">支持通过Syslog、SNMP、Trap、FTP、HTTP等方式对设备中的日志、事件、告警等信息进行集中管理。</div>
                  </div>
                  <div class="under-line-title mt-16 font-18">
                    <div class="under-line-title-title">分布式检索</div>
                    <div class="under-line-title-desc">
                      ES+分布式数据库实现快速告警检索，支持按照告警等级、告警来源、告警关键词等条件进行全文搜索功能。</div>
                  </div>
                </div>
              </div>
              <el-image :src="solutionImg82" :preview-src-list="[solutionImg82]" />
            </div>
          </div>
        </div>
      </div>

      <!-- 产品特色 -->
      <div class="section">
        <div class="title">产品特色</div>
        <div class="rows-4">
          <FeatureItem title="自学习资产测绘">
            <template #icon>
              <img src="./assets/feature01.svg" alt="" />
            </template>
          </FeatureItem>
          <FeatureItem title="一站式运维管理">
            <template #icon>
              <img src="./assets/feature02.svg" alt="" />
            </template>
          </FeatureItem>
          <FeatureItem title="业务画像分析">
            <template #icon>
              <img src="./assets/feature03.svg" alt="" />
            </template>
          </FeatureItem>
          <FeatureItem title="信创国产化">
            <template #icon>
              <img src="./assets/feature04.svg" alt="" />
            </template>
          </FeatureItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBg from "../../common/TopBg.vue";
import SolutionItemV2 from "../../common/solution-item_v2.vue";
import PainsAnalysisItem from "../../common/pains-analysis-item.vue";
import FeatureItem from "@/components/common/feature-item.vue";

export default {
  name: "DrgPlatform",
  components: {
    TopBg,
    FeatureItem,
    SolutionItemV2,
    PainsAnalysisItem,
  },
  data() {
    return {
      topBg: require("./assets/bg.png"),
      introImg: require("./assets/intro.png"),
      solutionImg11: require("./assets/solution11.png"),
      solutionImg12: require("./assets/solution12.png"),
      solutionImg21: require("./assets/solution21.png"),
      solutionImg31: require("./assets/solution31.png"),
      solutionImg32: require("./assets/solution32.png"),
      solutionImg41: require("./assets/solution41.png"),
      solutionImg51: require("./assets/solution51.png"),
      solutionImg61: require("./assets/solution61.png"),
      solutionImg71: require("./assets/solution71.png"),
      solutionImg81: require("./assets/solution81.png"),
      solutionImg82: require("./assets/solution82.png"),
    };
  },
};
</script>
